import { render } from "./Sidebar.vue?vue&type=template&id=e8b0a448&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=e8b0a448&lang=css"
import "./Sidebar.vue?vue&type=style&index=1&id=e8b0a448&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e8b0a448"

export default script